import React from "react";

export default function ChemicalPopover({ open, x, y, chemicals, onClose }) {
  if (!open) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: y + 8,
        left: x + 8,
        zIndex: 1001,
        background: "#fff",
        border: "1px solid #eee",
        borderRadius: 12,
        boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
        padding: 24,
        minWidth: 390,
        fontFamily: "inherit",
      }}
    >
      <div style={{ fontWeight: 700, fontSize: 17, marginBottom: 16 }}>Chemicals</div>
      <div>
        {(!chemicals || chemicals.length === 0) ? (
          <div style={{ color: "#888" }}>No chemicals</div>
        ) : (
          <table
            style={{
              borderCollapse: "collapse",
              width: "100%",
              border: "1px solid #bbb",
            }}
          >
            <thead>
              <tr>
                <th style={{ border: "1px solid #bbb", padding: "6px 8px", background: "#f7f7f7", textAlign: "left" }}>Code</th>
                <th style={{ border: "1px solid #bbb", padding: "6px 8px", background: "#f7f7f7", textAlign: "left" }}>Name</th>
                <th style={{ border: "1px solid #bbb", padding: "6px 8px", background: "#f7f7f7", textAlign: "left" }}>UOM</th>
                <th style={{ border: "1px solid #bbb", padding: "6px 8px", background: "#f7f7f7", textAlign: "right" }}>Value</th>
                <th style={{ border: "1px solid #bbb", padding: "6px 8px", background: "#f7f7f7", textAlign: "right" }}>QCR No</th>
              </tr>
            </thead>
            <tbody>
              {chemicals.map((c) => (
                <tr key={c.chemicalCode}>
                  <td style={{ border: "1px solid #bbb", fontWeight: 700, padding: "6px 8px" }}>
                    {c.chemicalCode}
                  </td>
                  <td style={{ border: "1px solid #bbb", padding: "6px 8px" }}>
                    {c.chemicalName}
                  </td>
                  <td style={{ border: "1px solid #bbb", padding: "6px 8px" }}>
                    {c.uom}
                  </td>
                  <td style={{ border: "1px solid #bbb", fontWeight: 700, padding: "6px 8px", textAlign: "right" }}>
                    {c.value}
                  </td>
                  <td style={{ border: "1px solid #bbb", padding: "6px 8px", textAlign: "right" }}>
                    {c.qcrNo}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
      <button
        style={{
          marginTop: 20,
          background: "#f31414",
          color: "#fff",
          border: 0,
          borderRadius: 6,
          padding: "8px 24px",
          cursor: "pointer",
          fontWeight: 500,
        }}
        onClick={onClose}
      >
        Close
      </button>
    </div>
  );
}
